import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DefaultService,
  PSCertMaterialItem,
  PSCertTriageMaterialItem,
  PSCertWorkItem,
  PSTriageCertWorkItem,
  UserDetails
} from '@psnb/psnb-api';
import { PowerSupplyService, PSCodeService } from '@psnb/services';
import {
  MaterialDeleteDialogComponent
} from 'desktop/power-supply/power-supply-edit/powersupply-certification-workitems/material-delete-dialog.component';
import {
  WorkItemDeleteDialogComponent
} from 'desktop/power-supply/power-supply-edit/powersupply-certification-workitems/work-item-delete-dialog.component';
import { ValidationErrorDialog } from 'desktop/power-supply/Upload/power-supply-bulk-upload/validation-error-dialog';

@Component({
  selector: 'app-powersupply-cert-workitem',
  templateUrl: './powersupply-cert-workitem.component.html',
  styleUrls: ['./powersupply-cert-workitem.component.scss']
})
export class PowersupplyCertWorkitemComponent implements OnInit {

  public userDetails: UserDetails;
  showProgressBar: boolean = false;
  disableplusicon: boolean = true;
  runtimeForm: FormGroup;
  notSuccess: boolean = false;
  getError: boolean = false;
  public rowData=[];
  private validationErrorDialog: MatDialogRef<ValidationErrorDialog>;
  id: number;
  psWorkItemId: number;
  workArrayData: any = [];
  addformShow: any;
  psworlItemId: any;
  certId: number;
  showPowerSupplyModel: boolean=false;
  error: boolean = false;
  permissionValue:any;
  triageId:number;
  macAddress:string;
  deleteDialogRef: MatDialogRef<WorkItemDeleteDialogComponent>;
  workItemDescArr : any = [];
  calCss: any;
  runtimeFormmat:FormGroup;
  deleteDialogmaterialRef: MatDialogRef<MaterialDeleteDialogComponent>;
  public rowDatamatType:any[]=[];
  public uniquerowDatamatType:any[]=[];
  public rowDatamatTypechanged = [];
  workArrayDataMaterial: any = [];
  psMaterialItemId: any;
  uniqueDatamatType: any = [];
  constructor(
    private ref: ChangeDetectorRef,
    private fb: FormBuilder, private pSCodeService: PSCodeService, private powerSupplyService: PowerSupplyService, public Service: DefaultService, private router: Router, private route: ActivatedRoute,private dialog: MatDialog,
    public dialogRef: MatDialogRef<PowersupplyCertWorkitemComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    @Inject(MAT_DIALOG_DATA) private disableClose,
  ) {
    this.addformShow = dialogRef.disableClose;
    this.triageId=this.data.triageId;

  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.macAddress=params['macAddress'];
      });
    this.userDetails = JSON.parse(localStorage['user-details']);
    if ((this.userDetails.permissions.includes('{1091}'))) {
      this.permissionValue = true;
    } else {
      this.permissionValue = false;
    }
     //get material type
    this.materialType();
    this.prepairForm();
    this.prepairFormmat();
    this.getPsbillingCodes();
    this.getData();
    //this.getPSCertificationID();
 //   this.getData();
    // this.items();
    // if (this.addformShow === 'Add')
    //   this.prepairForm();


  }

  public getworkItemData(){

  }

  public deleteWorkItemMaterial() {
    this.deleteDialogmaterialRef = this.dialog.open(
      MaterialDeleteDialogComponent, {
        data: {
          id:  this.psMaterialItemId,
          permissionValue: this.permissionValue
        },
        disableClose: true
      });

    this.deleteDialogmaterialRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getData();
      }
    });
  }

  public deleteWorkItem() {
    this.deleteDialogRef = this.dialog.open(
      WorkItemDeleteDialogComponent, {
        data: {
          id:  this.psworlItemId,
          permissionValue: this.permissionValue
        },
        disableClose: true
      });

    this.deleteDialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.getData();
      }
    });
  }

  //Function for getting all the certification id and single record
  getPSCertificationID() {
    this.powerSupplyService.getPSCertificationID(this.data.powerSupplyId,'').subscribe(certid => {
      this.certId = certid;
      this.getData();
     // this.prepairForm();
      if (this.certId != null) {
      }
    });

  }
  prepairForm() {
    this.runtimeForm = this.fb.group({
      items: this.fb.array([])
    });
    const ArrayWorkItemModelList = <FormArray>this.cwi.items;
    if (this.workArrayData.length == 0) {
      let newGroup = this.fb.group({
        billingCode: ['', Validators.required],
        //partNumbers: ['', Validators.required],
        quantity: [''],
        //workItemDesc: ['', Validators.required],
        psCertificationId: [this.data.certId],
        macaddress: [this.macAddress],
      });
      ArrayWorkItemModelList.push(newGroup);
    }

    if (this.workArrayData.length > 0 && this.addformShow != 'Add') {
      this.workArrayData.forEach(element => {
        this.calCss = '470px';
        let newGroup = this.fb.group({
          psWorkItemId: [element.psWorkItemId],
          billingCode: [element.workItemName + '-' + element.workItemDesc],
          //partNumbers: [element.partNumbers, Validators.required],
          //workItemDesc:[element.workItemDesc],
          quantity: [element.quantity],
          psCertificationId: [{ value: this.data.certId, disabled: true }],//[element.psCertificationId, Validators.required],
          macaddress: [this.macAddress],
        });
        ArrayWorkItemModelList.push(newGroup);
      });
    }
  }

  prepairFormmat() {
    this.runtimeFormmat = this.fb.group({
      items: this.fb.array([])
    });
    const ArrayWorkItemModelListmat = <FormArray>this.cwimat.items;
    if (this.workArrayDataMaterial.length == 0) {
      let newGroupmat = this.fb.group({
        materialType: ['', Validators.required],
        modelDesc: ['', Validators.required],
        quantitymat: [''],
        psCertificationId: [this.data.certId],
        macaddress: [this.macAddress],
      });
      ArrayWorkItemModelListmat.push(newGroupmat);
    }
    if (this.workArrayDataMaterial.length > 0 && this.addformShow != 'Add') {
      this.workArrayDataMaterial.forEach((element, index) => {
        setTimeout(() => {
          this.changematType(element.materialType, index)
          let newGroupmat = this.fb.group({
            psMaterialItemId: [element.psMaterialItemId],
            materialType: [element.materialType],
            modelDesc: [element.model+'~'+element.modelDescription],
            quantitymat: [element.quantity],
            psCertificationId: [{ value: this.data.certId, disabled: true }],//[element.psCertificationId, Validators.required],
            macaddress: [this.macAddress],
          });
          ArrayWorkItemModelListmat.push(newGroupmat);
        });
      });
    }
  }

  get cwi() { return this.runtimeForm.controls }

  get cwimat() { return this.runtimeFormmat.controls }
  itemsmat(): any {
    return this.runtimeFormmat.get('items');
  }

  items(): any {
    return this.runtimeForm.get('items');
  }

  addCertificationsWorkitem() {
    var length = this.workArrayData.length;
    var formlenth = this.runtimeForm.controls.items['controls'].length
    let c = length + formlenth;
    if (formlenth < 5) {
      const ArrayWorkItemModelList = <FormArray>this.cwi.items
      let newGroup = this.fb.group({
        billingCode: ['', Validators.required],
        //partNumbers: ['', Validators.required],
        quantity: [''],
        //workItemDesc: ['', Validators.required],
        psCertificationId: [this.data.certId],
        macaddress: [this.macAddress],
      });
      ArrayWorkItemModelList.push(newGroup);
    }
    else {
      let errMessage = "Maximum 5 Records are Allow";
      this.openDialog(errMessage);
    }
  }

  addCertificationsWorkitemmaterial() {
    var length = this.workArrayData.length;
    var formlenthmat = this.runtimeFormmat.controls.items['controls'].length
    if (formlenthmat < 5) {
      const ArrayWorkItemModelListmaterial = <FormArray>this.cwimat.items
      let newGroupmat = this.fb.group({
        materialType: ['', Validators.required],
        modelDesc : ['', Validators.required],
        quantitymat: [''],
        //quantity: [''],
        psCertificationId: [this.data.certId],
        macaddress: [this.macAddress],
      });
      ArrayWorkItemModelListmaterial.push(newGroupmat);
    }
    else {
      let errMessage = "Maximum 5 Records are Allow";
      this.openDialog(errMessage);
    }
  }

  removeCertificationsWorkitem(empIndex: number, items) {
    if (this.runtimeForm.controls.items['controls'].length >= 1) {
      if (items.value.psWorkItemId==undefined && this.runtimeForm.controls.items['controls'].length > 1) {
        const ArrayWorkItemModelList = <FormArray>this.cwi.items;
        ArrayWorkItemModelList.removeAt(empIndex)
      }
      else if(items.value.psWorkItemId!=undefined){
       this.psworlItemId = items.value.psWorkItemId
       this.deleteWorkItem();
      }

    }

  }

  removeCertificationsmmaterial(matIndex: number, itemsmaterial) {
     if (this.runtimeFormmat.controls.items['controls'].length >= 1) {
      if (itemsmaterial.value.psMaterialItemId==undefined && this.runtimeFormmat.controls.items['controls'].length > 1) {
        const ArrayWorkItemModelListmaterial = <FormArray>this.cwimat.items;
        ArrayWorkItemModelListmaterial.removeAt(matIndex)
      }
      else if(itemsmaterial.value.psMaterialItemId!=undefined){
       this.psMaterialItemId = itemsmaterial.value.psMaterialItemId
       this.deleteWorkItemMaterial();
      }

    }

  }

  removeworkItemData(empIndex: number) {
    if (this.runtimeForm.controls.items['controls'].length > 1) {
      this.items().removeAt(empIndex);
    }
  }

  SortByName(x, y) {
    return ((x == y) ? 0 : ((x > y) ? 1 : -1));
  }

  // materialType(){
  //   this.pSCodeService.getmaterialType().subscribe((res) => {
  //     setTimeout(() => {
  //       res.forEach((itemDatamatType, index) => {
  //         this.rowDatamatType.push(itemDatamatType['materialType']);
  //     });
  //     });
  //      this.rowDatamatType.sort(this.SortByName);
  //      this.ref.markForCheck()
  //   }, err => {
  //     if (err.status === 401) {
  //       this.router.navigate(['/unauthorized']);
  //     }
  //   });
  // }

  materialType(){

    const promisegetmaterialType = new Promise((resolve, reject) => {
      this.pSCodeService.getmaterialType().subscribe((res) => {
        // setTimeout(() => {
           res.forEach((itemDatamatType, index) => {
           this.rowDatamatType.push(itemDatamatType['materialType']);
         });
          resolve(res);
        }, err => {
          reject(err);
        });
    });
    Promise.all([promisegetmaterialType]).then(([materialType]) => {
      var data = <any>this.rowDatamatType;
      this.uniqueDatamatType = [...new Set(data.map(item => item))];
      //this.uniquerowDatamatType.push(this.unique);

    });

    }

    changematType(result, index){
      this.rowDatamatTypechanged[index] = [];
      this.pSCodeService.getchangematerialType(result).subscribe((res) => {
        res.forEach(changedmatType => {
          this.rowDatamatTypechanged[index].push(changedmatType['model']+'~'+changedmatType['modelDescription']);
         });
      }, err => {
        if (err.status === 401) {
          this.router.navigate(['/unauthorized']);
        }
      });
    }


  openDialog(message: string) {
    this.validationErrorDialog = this.dialog.open(ValidationErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.validationErrorDialog.afterClosed().subscribe(() => { });
  }

  getPsbillingCodes() {
    this.pSCodeService.getPsBillingCodes().subscribe((res) => {
    this.workItemDescArr = res;
    setTimeout(() => {
      res.forEach((itemData, index) => {
        // if (this.rowData.length && !this.rowData.includes('-')){
        //   this.rowData.splice(index, 0)
        // }
        this.rowData.push(itemData['workItem']+'-'+itemData['workItemDescription']);
    });
    // this.ref.detectChanges()
    this.ref.markForCheck()
    });
      this.rowData.sort(this.SortByName);

      this.showProgressBar = false;
    }, err => {
      if (err.status === 401) {
        this.router.navigate(['/unauthorized']);
      }
    });
  }

  addWorkitem() {
    if(this.workArrayData.length<5) {
      if(this.permissionValue ==true) {
        this.showProgressBar = true;
        var formData = []
        this.runtimeForm.value.items.forEach(element => {
        var splitKeydata = element.billingCode.split('-')
        var model: PSCertWorkItem = {};

        let arr = new Array();
        let idx = element.billingCode.indexOf('-');
        arr[0] = element.billingCode.substring(0, idx);
        arr[1] = element.billingCode.substring(idx+1);
        let workItemDescmessage = arr[1];

        model.workItemName = splitKeydata[0];
        model.quantity = (element.quantity === null || element.quantity === '') ? 1 : element.quantity;
        model.workItemDesc = workItemDescmessage;
        //model.partNumbers = element.partNumbers;
        model.psCertificationId = this.data.certId;
        //model.workItemDesc = element.workItemDesc;
        model.powerSupplyId = this.data.powerSupplyId;
        model.macAddress = this.macAddress;
        formData.push(model)
        });
         if (formData.length > 0) {
          this.powerSupplyService.saveWorkItemData(formData).subscribe(result => {
            if (result['success'] === true) {
              this.showProgressBar = false;
              this.dialogRef.close();
             //this.getData();
              // let errMessage = "Work Item Added Successfully";
              // this.openDialog(errMessage);
            } else {
              this.notSuccess = true
              this.showProgressBar = false;
            }
          },err => {
              this.notSuccess = true;
              this.showProgressBar = false;
          });
        }

        //Add Material
        var formDataMaterial = []
        this.runtimeFormmat.value.items.forEach(element => {
          var splitKeydatamat = element.modelDesc.split('~')
          let arr = new Array();
          let idx = element.modelDesc.indexOf('~')
          arr[0] = element.modelDesc.substring(0, idx);
          arr[1] = element.modelDesc.substring(idx+1);
          let matDescmessage = arr[1]
          var modelmat: PSCertMaterialItem = {};
          modelmat.materialType = element.materialType;
          modelmat.model = splitKeydatamat[0];
          modelmat.modelDescription = matDescmessage;
          modelmat.quantity = (element.quantitymat === null || element.quantitymat === '') ? 1 : element.quantitymat;
          modelmat.psCertificationId = this.data.certId;
          modelmat.powerSupplyId = this.data.powerSupplyId;
          modelmat.macAddress = this.macAddress;
          formDataMaterial.push(modelmat)
        });
        if (formDataMaterial.length > 0) {
          this.powerSupplyService.saveMaterialItem(formDataMaterial).subscribe(result => {
            if (result['success'] === true) {
              this.showProgressBar = false;
              this.dialogRef.close();
              //this.getData();
              // let errMessage = "Material Added Successfully";
              // this.openDialog(errMessage);
            } else {
              this.notSuccess = true
              this.showProgressBar = false;
            }
            let saveMessage ="Work Item and Material Added Successfully";
            this.openDialog(saveMessage)
          }, err => {
            this.notSuccess = true;
            this.showProgressBar = false;
          });
        }

      } else {
        this.showProgressBar = true;
        var formData = []
        this.runtimeForm.value.items.forEach(element => {
        var splitKeydata = element.billingCode.split('-')
        var model: PSTriageCertWorkItem = {};

        let arr = new Array();
        let idx = element.billingCode.indexOf('-');
        arr[0] = element.billingCode.substring(0, idx);
        arr[1] = element.billingCode.substring(idx+1);
        let workItemDescmessage = arr[1];


        model.triageId=(this.triageId)?this.triageId:null;
        model.workItemName = splitKeydata[0];
        model.quantity = (element.quantity === null || element.quantity === '') ? 1 : element.quantity;
        model.workItemDesc = workItemDescmessage;
        //model.partNumbers = element.partNumbers;
        //model.workItemDesc = element.workItemDesc;
        model.psCertificationId = this.data.certId;
        model.powerSupplyId = this.data.powerSupplyId;
        model.macAddress = this.macAddress;
        formData.push(model)
        });
        this.powerSupplyService.saveTriageWorkItem(formData).subscribe(result => {
          if (result) {
            this.showProgressBar = false;
          this.dialogRef.close();
            // let errMessage = "Work Item Added Successfully";
            // this.openDialog(errMessage);
          } else {
            this.notSuccess = true
            this.showProgressBar = false;
          }
        },err => {
            this.notSuccess = true;
            this.showProgressBar = false;
        });

         //Add Material
         var formDataMaterial = []
         this.runtimeFormmat.value.items.forEach(element => {
         var splitKeydatamat = element.modelDesc.split('~')
         let arr = new Array();
         let idx = element.modelDesc.indexOf('~')
         arr[0] = element.modelDesc.substring(0, idx);
         arr[1] = element.modelDesc.substring(idx+1);
        let matDescmessage = arr[1]
         var modelmat: PSCertTriageMaterialItem = {};
         modelmat.triageId=(this.triageId)?this.triageId:null;
         modelmat.materialType = element.materialType;
         modelmat.model = splitKeydatamat[0];
         modelmat.modelDescription = matDescmessage;
         modelmat.quantity = (element.quantitymat === null || element.quantitymat === '') ? 1 : element.quantitymat;
         modelmat.psCertificationId = this.data.certId;
         modelmat.powerSupplyId = this.data.powerSupplyId;
         modelmat.macAddress = this.macAddress;
         formDataMaterial.push(modelmat)
         });
         if(formDataMaterial.length > 0){
           this.powerSupplyService.saveTriageMaterialItem(formDataMaterial).subscribe(result => {
             if (result['success'] === true) {
               this.showProgressBar = false;
               this.dialogRef.close();
             //this.getData();
               // let errMessage = "Material Added Successfully";
               // this.openDialog(errMessage);
             } else {
               this.notSuccess = true
               this.showProgressBar = false;
             }
             let saveMessage ="Work Item and Material Added Successfully";
             this.openDialog(saveMessage)
           },err => {
               this.notSuccess = true;
               this.showProgressBar = false;
           });
         }
      }
    } else{
      let errMessage = "Already Added 5 Work Items";
      this.openDialog(errMessage);
    }
  }

  changePowerSupplyModel(result, index) {
    this.calCss = '470px';
    var splitKey = result.value.split('-')
    if (result.value == '' || result.value == undefined) {
      this.showPowerSupplyModel = true;
    }
    // else {
    //   this.workItemDescArr.forEach((itemData) => {
    //     if (itemData.workItem == splitKey[0]) {
    //       this.calCss = itemData.workItemDescription.length * 8 + 'px';
    //       this.runtimeForm.controls.items['controls'][index].controls.workItemDesc.patchValue(itemData.workItemDescription);
    //       this.runtimeForm.controls.items['controls'][index].controls.workItemDesc.clearValidators();
    //       this.runtimeForm.controls.items['controls'][index].controls.workItemDesc.updateValueAndValidity();
    //     }
    //   });
    // }
  }

  isSelectedmaterial(ingredientDataMat) {
    return this.runtimeFormmat.get('items').value.find(item => ingredientDataMat === item.modelDesc);
  }

  EditWorkiteData() {
    if(this.showPowerSupplyModel==true){
    return;
    }
    if(this.permissionValue ==true) {
      this.showProgressBar = true;
      //this.runtimeForm.value.items;
      var formData = []
      this.runtimeForm.value.items.forEach(element => {
      var splitKeydata = element.billingCode.split('-')

      let arr = new Array();
      let idx = element.billingCode.indexOf('-');
      arr[0] = element.billingCode.substring(0, idx);
      arr[1] = element.billingCode.substring(idx+1);
      let workItemDescmessage = arr[1];

      var model: PSCertWorkItem = {};
      model.psWorkItemId = element.psWorkItemId
      //model.workItemName = element.billingCode;
      model.workItemName = splitKeydata[0];
      model.quantity = (element.quantity === null || element.quantity === '') ? 1 : element.quantity;
      model.workItemDesc = workItemDescmessage;
      //model.partNumbers = element.partNumbers;
      model.psCertificationId = this.data.certId;
      model.powerSupplyId = this.data.powerSupplyId;
      model.macAddress = this.macAddress;
      formData.push(model);
      });
      // this.runtimeForm.value.items.forEach(element => {
      //   model.workItemName = element.billingCode;
      //   model.quantity = element.quantity;
      //   //model.macAddress = element.macaddress;
      //   model.psCertificationId = this.certId;
      //   model.partNumbers = element.partNumbers;
      //   // model.partNumbers ='test';
      //   model.powerSupplyId = this.data;
      //   model.psWorkItemId = element.psWorkItemId


      // });
      // formData.push(model)
      this.powerSupplyService.editWorkItemData(formData).subscribe(result => {
        if (result['success'] === true) {
          this.showProgressBar = false;
          this.dialogRef.close();
         //this.getData();

          //  let errMessage = "Work Item Updated Successfully";
          // this.openDialog(errMessage);
        } else {
          this.notSuccess = true
          this.showProgressBar = false;
        }
      },err => {
          this.notSuccess = true;
          this.showProgressBar = false;
      });

      //edit material
      var formDataMaterial = []
      this.runtimeFormmat.value.items.forEach(element => {

      var splitKeydatamat = element.modelDesc.split('~');
      let arr = new Array();
      let idx = element.modelDesc.indexOf('~');
      arr[0] = element.modelDesc.substring(0, idx);
      arr[1] = element.modelDesc.substring(idx+1);
      let matDescmessage = arr[1];

      var modelmat: PSCertMaterialItem = {};
      modelmat.psMaterialItemId = element.psMaterialItemId;
      modelmat.materialType = element.materialType;
      modelmat.model = splitKeydatamat[0];
      modelmat.modelDescription = matDescmessage;
      modelmat.quantity = (element.quantitymat === null || element.quantitymat === '') ? 1 : element.quantitymat;
      modelmat.psCertificationId = this.data.certId;
      modelmat.powerSupplyId = this.data.powerSupplyId;
      modelmat.macAddress = this.macAddress;
      formDataMaterial.push(modelmat);
      });

      this.powerSupplyService.editMaterialItem(formDataMaterial).subscribe(result => {
        if (result['success'] === true) {
          this.showProgressBar = false;
          this.dialogRef.close();
          // let errMessage = "Material Updated Successfully";
          // this.openDialog(errMessage);
        } else {
          this.notSuccess = true
          this.showProgressBar = false;
        }
        let saveMessage ="Work Item and Material Updated Successfully";
        this.openDialog(saveMessage)
      },err => {
          this.notSuccess = true;
          this.showProgressBar = false;
      });
    } else {
      this.showProgressBar = true;
      var formData = []
      this.runtimeForm.value.items.forEach(element => {
      var model: PSTriageCertWorkItem = {};

      let arr = new Array();
      let idx = element.billingCode.indexOf('-');
      arr[0] = element.billingCode.substring(0, idx);
      arr[1] = element.billingCode.substring(idx+1);
      let workItemDescmessage = arr[1];


      var splitKeydata = element.billingCode.split('-')
      model.psWorkItemId = element.psWorkItemId
      model.triageId=(this.triageId)?this.triageId:null;
      model.workItemName = splitKeydata[0];
      model.quantity = (element.quantity === null || element.quantity === '') ? 1 : element.quantity;
      model.workItemDesc = workItemDescmessage;
     // model.partNumbers = element.partNumbers;
      model.psCertificationId = this.data.certId;
      model.powerSupplyId = this.data.powerSupplyId;
      model.macAddress = this.macAddress;
      formData.push(model);
      });
      this.powerSupplyService.editTriageWorkItem(formData).subscribe(result => {
        if (result['success'] === true) {
          this.showProgressBar = false;
          this.dialogRef.close();
          //let errMessage = "Work Item Updated Successfully";
          //this.openDialog(errMessage);
        } else {
          this.notSuccess = true
          this.showProgressBar = false;
        }
      },err => {
          this.notSuccess = true;
          this.showProgressBar = false;
      });

       //edit material
       var formDataMaterial = []
       this.runtimeFormmat.value.items.forEach(element => {
       var splitKeydatamat = element.modelDesc.split('~')
       let arr = new Array();
       let idx = element.modelDesc.indexOf('~')
       arr[0] = element.modelDesc.substring(0, idx);
       arr[1] = element.modelDesc.substring(idx+1);
      let matDescmessage = arr[1]
       var modelmat: PSCertTriageMaterialItem = {};
       modelmat.triageId=(this.triageId)?this.triageId:null;
       modelmat.psMaterialItemId = element.psMaterialItemId;
       modelmat.materialType = element.materialType;
       modelmat.model = splitKeydatamat[0];
       modelmat.modelDescription = matDescmessage;
       modelmat.quantity = (element.quantitymat === null || element.quantitymat === '') ? 1 : element.quantitymat;
       modelmat.psCertificationId = this.data.certId;
       modelmat.powerSupplyId = this.data.powerSupplyId;
       modelmat.macAddress = this.macAddress;
       formDataMaterial.push(modelmat)
       });

       this.powerSupplyService.editTriageMaterial(formDataMaterial).subscribe(result => {
         if (result['success'] === true) {
           this.showProgressBar = false;
           this.dialogRef.close();
           // let errMessage = "Material Updated Successfully";
           // this.openDialog(errMessage);
         } else {
           this.notSuccess = true
           this.showProgressBar = false;
         }
         let saveMessage ="Work Item and Material Updated Successfully";
         this.openDialog(saveMessage)
       },err => {
           this.notSuccess = true;
           this.showProgressBar = false;
       });
    }
  }
  delete() {
    if (this.psworlItemId !== null || this.psworlItemId !== undefined) {
      this.powerSupplyService.deleteControllerWorkItem(this.psworlItemId).subscribe(result => {
        if (result.success === true) {
          this.dialogRef.close(result.success);
          let errMessage = "Work Item Deleted Successfully";
          this.openDialog(errMessage);
          //this.getData();
        }
         else this.error = true;
      })
    }
  }

  isSelected(ingredientData) {
    return this.runtimeForm.get('items').value.find(item => ingredientData === item.billingCode);
  }

  getData() {
    if(this.permissionValue==true) {
      this.showProgressBar = true;
      this.powerSupplyService.getWorkItemsByPowerSupplyId(this.data.powerSupplyId, this.data.certId).subscribe(res => {
        if (res) {
          this.id = res['id'];
          this.workArrayData = res;
          this.prepairForm();
          this.showProgressBar = false;
          /*this.runtimeForm.patchValue({
           // macaddress: res['macaddress'],
            quantity: res['quantity'],

          });*/
        } else this.id = 0;
        // this.markAsTouched(this.supplyFormGroup);
        // this.ref.detectChanges();
        this.showProgressBar = false;
      }, err => {
        // this.markAsTouched(this.supplyFormGroup);
        // this.ref.detectChanges();
        this.showProgressBar = false;
      });

      this.powerSupplyService.getMaterialItemsByPsId(this.data.powerSupplyId, this.data.certId).subscribe(resmat => {
        if (resmat) {
          this.id = resmat['id'];
          this.workArrayDataMaterial = resmat;
          this.prepairFormmat();
          this.showProgressBar = false;
        } else this.id = 0;
        this.showProgressBar = false;
      }, err => {
        this.showProgressBar = false;
      });
    } else {
      this.showProgressBar = true;
      if(this.triageId == null || this.triageId == undefined) {
        this.powerSupplyService.getTriageWorkItemsBYPsCertID(this.data.certId,this.data.powerSupplyId, this.triageId).subscribe(res => {
          if (res) {
            this.workArrayData = res;
            this.prepairForm();
            this.showProgressBar = false;
            /*this.runtimeForm.patchValue({
             // macaddress: res['macaddress'],
              quantity: res['quantity'],

            });*/
          } else {
            this.getError = true;
            this.showProgressBar = false;
          }
          this.showProgressBar = false;
        }, err => {
          this.getError = true;
          this.showProgressBar = false;
        });
        //get material
        this.powerSupplyService.getTriageMaterialItemsBYPsCertID(this.data.certId,this.data.powerSupplyId, this.triageId).subscribe(resmat => {
          if (resmat) {
            this.workArrayDataMaterial = resmat;
            this.prepairFormmat();
            this.showProgressBar = false;
          } else {
            this.getError = true;
            this.showProgressBar = false;
          }
          this.showProgressBar = false;
        }, err => {
          this.getError = true;
          this.showProgressBar = false;
        });
      } else {
        this.powerSupplyService.getTriageWorkItems(this.triageId).subscribe(res => {
          if (res) {
            this.workArrayData = res;
            this.prepairForm();
            this.showProgressBar = false;
            /*this.runtimeForm.patchValue({
             // macaddress: res['macaddress'],
              quantity: res['quantity'],

            });*/
          } else {
            this.getError = true;
            this.showProgressBar = false;
          }
          this.showProgressBar = false;
        }, err => {
          this.getError = true;
          this.showProgressBar = false;
        });

        this.powerSupplyService.getTriageMaterialItems(this.triageId).subscribe(resmat => {
          if (resmat) {
            this.workArrayDataMaterial = resmat;
            this.prepairFormmat();
            this.showProgressBar = false;
          } else {
            this.getError = true;
            this.showProgressBar = false;
          }
          this.showProgressBar = false;
        }, err => {
          this.getError = true;
          this.showProgressBar = false;
        });
      }
    }
  }
}


